import React from 'react';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const useStyles = buildUseStyles('RequestChurnButton', () => ({
  root: {
    textAlign: 'center',
  },
}));

const RequestChurn = ({
  resource,
}) => {
  const classes = useStyles();
  const { loadModalCollectionByLink } = useModalContext();

  const handleClick = () => {
    const selectLink = resource
      .relationship(fr.relationships.requestChurn.name)
      .link('related')
      .url();

    loadModalCollectionByLink(selectLink);
  };

  return (
    <Box className={classes.root}>
      <RoundedButton
        size={'sm'}
        fullWidth
        onClick={() => handleClick()}
        test={'request-churn-link'}
      >
        {'Request Cancellation'}
      </RoundedButton>
    </Box>
  );
};

RequestChurn.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default RequestChurn;
